/** A method used to update labels on the front end.
 *  This is used when some labels are coming from the backend, and we
 *  need to simply display a different label.  
 *  This should only be used when updating across the backend is decided to, 
 *  in the moment, not be the right round 1 decision.
 */

const LABEL_UPDATES = {
  // Sight Recognition to High Frequency Words
  "Sight Recognition": "High Frequency Words",
  "ESRI": "EHFWI",
  "IERV": "IEPAF"
}

export function getUpdatedLabel(label) {
  const updatedLabel = LABEL_UPDATES[label];
  if (updatedLabel) {
    return updatedLabel;
  }

  return label;
}

export default getUpdatedLabel;